import { render, staticRenderFns } from "./UploadInput.vue?vue&type=template&id=5caf2e54&"
import script from "./UploadInput.vue?vue&type=script&lang=js&"
export * from "./UploadInput.vue?vue&type=script&lang=js&"
import style0 from "./UploadInput.vue?vue&type=style&index=0&id=5caf2e54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports